// Value shown in a table cell (computed columns included). Used by stats, Excel export and summary.
export function cellValue(c, r, blindOffsets) {
    if (c.calc === "blindW" || c.calc === "blindH") {
        const isW = c.calc === "blindW";
        const d = Number(isW ? r.width : r.height);
        if (!Number.isFinite(d) || d <= 0) return null;
        return d + Number((isW ? r.blindOffW : r.blindOffH) ?? (isW ? blindOffsets?.width : blindOffsets?.height) ?? 0);
    }
    if (c.calc === "area") return rowArea(r);
    return r[c.key] ?? null;
}

export function rowArea(r) {
    const w = Number(r.width), h = Number(r.height);
    if (!(w > 0) || !(h > 0)) return null;
    const q = Number(r.qty) || 0;
    return Math.round(((w * h * q) / 1e6) * 1000) / 1000;
}

const toNum = (v) => {
    if (typeof v === "number") return Number.isFinite(v) ? v : null;
    const s = String(v ?? "").trim().replace(/\s/g, "").replace(",", ".");
    return s !== "" && /^[-+]?\d*\.?\d+$/.test(s) ? Number(s) : null;
};

export function selectionStats(values) {
    const nonEmpty = values.filter((v) => v != null && String(v).trim() !== "");
    const nums = nonEmpty.map(toNum).filter((n) => n != null);
    const sum = nums.reduce((a, b) => a + b, 0);
    return {
        cells: values.length, filled: nonEmpty.length, empty: values.length - nonEmpty.length, numCount: nums.length,
        sum, avg: nums.length ? sum / nums.length : null,
        min: nums.length ? Math.min(...nums) : null, max: nums.length ? Math.max(...nums) : null,
    };
}
